module.exports = __webpack_public_path__ + "img/Salesman.d2a25a4a.svg";